export enum Types {
  CONNECTIVITY_SET_CONNECTION = 'connectivity/SET_CONNECTION'
}
